import React, { useState, useEffect } from "react";

const ImageSlider = ({ images, interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showWarning, setShowWarning] = useState(false);

  const handleRightClick = (e) => {
    e.preventDefault();
    setShowWarning(true);
  }

  useEffect(() => {
    const sliderInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    return () => clearInterval(sliderInterval);
  }, [images, interval]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="relative mx-auto w-fit">
      <div className="relative  sm:w-[320px] md:w-[650px] lg:w-[700px] w-[330px] mx-3  rounded-md overflow-hidden pb-10">
        {
          showWarning && (
            <div className="bg-gray-700" style={{
              position: 'fixed',
              top: '45%',
              left: '61%',
              transform: 'translate(-45%, -61%)',
              color: 'white',
              padding: '6px 15px',
              zIndex: 1000,
              fontSize: '10px'
            }}>
              <div className="flex justify-between mb-3">
                <h3 className="font-bold text-md">
                  WARNING
                </h3>
                <button
                  onClick={() => setShowWarning(false)}
                  style={{
                    marginLeft: '10px',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 'bolder',
                  }}
                >
                  X
                </button>
              </div>
              <span>
                All content is protected by copyright and may not be <br /> downloaded or copied.
              </span>

            </div>
          )
        }

        <div
          className="flex transition-transform duration-500"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >

          {images.map((image, index) => (
            <>
              <img
                key={index}
                src={image}
                onContextMenu={(e) => {
                  handleRightClick(e)
                }}
                alt={`Slide ${index}`}
                className="w-full h-full object-contain"
              />

            </>
          ))}
        </div>
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex lg:space-x-2 sm:space-x-5 md:space-x-4 space-x-5">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full border-2 ${index === currentIndex
                ? "bg-black border-black"
                : "bg-gray-300 border-gray-400"
                } transition-all`}
            ></button>
          ))}
        </div>
      </div>
      <button
        onClick={prevSlide}
        className="absolute top-1/2 left-[-40px] transform -translate-y-1/2 bg-white border-2 text-md text-black shadow-md p-3 rounded-full hover:bg-black hover:text-white transition-all lg:block sm:hidden md:hidden hidden"
      >
        &#8249;
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-1/2 right-[-40px] transform -translate-y-1/2 bg-white text-md text-black shadow-md p-3 rounded-full hover:bg-black hover:text-white transition-all lg:block sm:hidden md:hidden hidden"
      >
        &#8250;
      </button>
    </div>
  );
};

export default ImageSlider;
